import { render, staticRenderFns } from "./contactData.vue?vue&type=template&id=7c778ce5&"
import script from "./contactData.vue?vue&type=script&lang=js&"
export * from "./contactData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports